import { gql } from '@apollo/client';
import { PostProject } from '../contentPage/postDetail';
import { PostSubcategory } from '../../common/helpers/domain/postCategories';
import { VideoType } from '../../common/helpers/domain/videoTypes';
import { Tag } from '../fragments/project';

export const ARTICLE_BLOCK_QUERY = gql`
  query ArticleBlock {
    articleBlock: articleBlockPosts {
      items {
        id
        title
        propertyType
        author {
          id
          name
          nickname
          description
          link
          total_post
        }
        tags {
          id
          name
          link
        }
        project {
          id
          name
          propertyType
          developer
          roomTypes {
            name
          }
          location {
            zone {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
            district {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
            road {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
          }
          transportations {
            value
            label
            link
          }
          priceTypes {
            starting_price
            level {
              value
              label
            }
          }
        }
        postCategory
        link
        videoType
        featuredImage {
          url
          title
          width
          height
        }
        totalComments
        embedVideo
        excerpt
      }
    }
  }
`;

export interface ArticleBlockPost {
  id: number;
  title: string;
  propertyType: string[];
  author: ArticleBlockAuthor;
  tags: Tag[];
  project: PostProject;
  postCategory: PostSubcategory;
  link: string;
  videoType: VideoType;
  featuredImage: {
    url: string;
    title: string;
    width: number;
    height: number;
  };
  totalComments: number;
  embedVideo: string;
  excerpt: string;
}

export interface ArticleBlockAuthor {
  id: number;
  name: string;
  nickname: string;
  description: string;
  link: string;
  total_post: number;
  tags: Tag[];
}

export interface ArticleBlockQueryResponse {
  articleBlock: {
    items: ArticleBlockPost[];
  };
}
